// Site mode prefixes
export const SITEMODE_STERLING = 'sterling-stuller-com'
export const SITEMODE_SHOWCASE = 'showcase'
export const SITEMODE_SHOWCASE_IFRAME = 'showcase-iframe'
export const SITEMODE_SHOWCASE_IFRAME_CATEGORYEMBED = 'showcase-iframe-categoryembed'
export const SITEMODE_SHOWCASE_IFRAME_CATEGORYEMBED_WITH_ID = 'showcase-iframe-categoryembed-with-id'
export const SITEMODE_PUNCHOUT = 'showcase-punchout'
